<app-website-header></app-website-header>

<br><br>
<div>
        <section id="about" class="wow fadeInUp">
                <div class="container">                    
                        <form [formGroup]="form" (ngSubmit)="submit()" class="form-styles">
                            <div class="form-group">
                                <div class="form-row">
                                    <div class="col-md-6">
                                        <label for="first">Your Name</label>
                                        <input type="first" pattern="[a-zA-Z ]*" class="form-control" id="first" name="first"
                                             formControlName="ur_name" >
                                        <!-- <div *ngIf="firstref.errors &&(firstref.touched || firstref.dirty)" class="alert alert-danger">
                                            <div [hidden]="!firstref.errors?.pattern">
                                                Please use Alphabets only
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="col-md-6">
                                        <label for="last">Referrals Name</label>
                                        <input type="first" pattern="[a-zA-Z ]*" class="form-control" id="last" name="last" ngModel #lastref="ngModel"
                                            [(ngModel)]="referrals_name" [ngModelOptions]="{standalone: true}">
                                        <div *ngIf="lastref.errors &&(lastref.touched || lastref.dirty)" class="alert alert-danger">
                                            <div [hidden]="!lastref.errors?.pattern">
                                                Please use Alphabets only
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="form-row">
                                    <div class="col-md-6">
                                        <label for="email">Email</label>
                                        <input type="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" class="form-control" id="email"
                                            name="email" ngModel #emailref="ngModel" [(ngModel)]="referrals_email" [ngModelOptions]="{standalone: true}">
                                        <div *ngIf="emailref.errors &&(emailref.touched || emailref.dirty)" class="alert alert-danger">
                                            <div [hidden]="!emailref.errors?.pattern">
                                                Invalid pattern
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="mobile">Referrals Phone</label>
                                        <input type="mobile" pattern="^((\\+91-?)|0)?[0-9]{10}$" minlength="10" maxlength="12" class="form-control"
                                            id="mobile" name="mobile" ngModel #mobileref="ngModel" [(ngModel)]="referrals_Phone" [ngModelOptions]="{standalone: true}">
                                        <div *ngIf="mobileref.errors &&(mobileref.touched || mobileref.dirty)" class="alert alert-danger">
                                            <div [hidden]="!mobileref.errors?.pattern">
                                                Invalid Pattern
                                            </div>
                                    
                                            <div [hidden]="!mobileref.errors?.minlength">
                                                Number must be atleast 10 numbers
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="form-row">
                                    <div class="col-md-12">
                                        <label for="exampleInputEmail1">Comments &amp; Questions</label>
                                        <textarea class="form-control" id="comment" name="comment" [(ngModel)]="referrals_comments" [ngModelOptions]="{standalone: true}"> </textarea>
                                        
                                    </div>
                                </div>
                            </div>
                           
                            <button class="btn btn-styles btn-primary" type="submit" [disabled]="!form.valid">Submit</button>
                        </form>
                    </div>
            </section>

            <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
                <p style="color: white">Loading </p>  
                </ngx-spinner> 
</div>